<section class="client-section">
        <div class="slider">
            <div class="slide-track">
                <ng-container *ngFor="let slide of slides">
                    <div class="slide"><img [src]="slide.img" [alt]="slide.title" loading="lazy"></div>
                </ng-container>
                <ng-container *ngFor="let slide of slides">
                    <div class="slide" ><img [src]="slide.img" [alt]="slide.title" loading="lazy"></div>
                </ng-container>
            </div>
        </div>
</section>